module.exports = __webpack_public_path__ + "static/img/phone_ico_qrcode.c6d44c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultural_products/phone_ico_qrcode.png
// module id = 1oUV
// module chunks = 0